import { USER_LIST_BY_TYPE } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case USER_LIST_BY_TYPE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case USER_LIST_BY_TYPE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case USER_LIST_BY_TYPE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
